import { Future } from "@siteimprove/alfa-future";
import { Iterable } from "@siteimprove/alfa-iterable";
import { List } from "@siteimprove/alfa-list";
import { None } from "@siteimprove/alfa-option";
import { Cache } from "./cache.js";
/**
 * @public
 * * I: type of Input for rules
 * * T: possible types of test targets
 * * Q: questions' metadata type
 * * S: possible types of questions' subject.
 */
export class Audit {
    static of(input, rules, oracle = () => Future.now(None)) {
        return new Audit(input, List.from(rules), oracle);
    }
    _input;
    _rules;
    _oracle;
    constructor(input, rules, oracle) {
        this._input = input;
        this._rules = rules;
        this._oracle = oracle;
    }
    evaluate(performance) {
        const outcomes = Cache.empty();
        return Future.traverse(this._rules, (rule) => rule.evaluate(this._input, this._oracle, outcomes, performance)).map(Iterable.flatten);
    }
}
//# sourceMappingURL=audit.js.map